export const MACAW_ROOT_ID = 'chat-bi-root';

export function getMacawRoot(): HTMLElement {
  return document.getElementById(MACAW_ROOT_ID) ?? document.body;
}
